import { DefaultError, useMutation } from "@tanstack/react-query";
import { updateDefaultPage } from "../api/updateDefaultPage";
import { invalidatePagesListByBrandsQuery } from "../queries/usePagesListByBrandQuery";

type Params = {
  brandId: string;
  pageId: string;
};

export const useAuthenticatedPageMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updateDefaultPage({
        ...params,
        defaultPageType: "isDefaultForAuthenticated",
      });
    },
    onSuccess: (_, { brandId }) => {
      invalidatePagesListByBrandsQuery(brandId);
    },
    onError: (e) => {
      console.error("Error occurred when set page as authorized default", e);
    },
  });
};
